<form [formGroup]="dummyFormGroup" action="" (submit)="onSearchValueChange(SearchField.value)">
  <mat-form-field>
    <mat-label>Søg på adresse, måler eller forbruger</mat-label>
    <input #SearchField matInput type="search" [formControl]="control" autocorrect="off" [matAutocomplete]="auto" />
    <button mat-button matSuffix aria-label="Søg" (click)="onSearchValueChange(SearchField.value)" (focus)="SearchField.focus()">
      <mat-icon svgIcon="search"></mat-icon>
    </button>
  </mat-form-field>
  <mat-autocomplete #auto="matAutocomplete" [autoActiveFirstOption]="true" (optionSelected)="onSearchValueChange($event.option.value)">
    @for (option of filteredOptions$ | async; track option) {
      <mat-option [value]="option">
        {{ option }}
      </mat-option>
    }
  </mat-autocomplete>
</form>
